export default function asset(src: string | null | undefined): string {
  if (!src) return "";

  if (src.startsWith("http")) return src;
  return `${window.location.origin}/storage/${src}`;
}
